/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IEspecialty } from 'app/shared/model/especialty.model';
import { ILanguage } from 'app/shared/model/language.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface ISpecialityVitals {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  title?: string | null;
  unitsOfMeasure?: string | null;
  valueType?: string | null;
  normalRangeLowerLimit?: string | null;
  normalRangeUpperLimit?: string | null;
  possibleRangeLowerLimit?: string | null;
  possibleRangeUpperLimit?: string | null;
  symptom?: string | null;
  subSpeciality?: string | null;
  group?: string | null;
  forAppointment?: boolean | null;
  forPrescription?: boolean | null;
  subGroup?: string | null;
  country?: string | null;
  sortOrder?: number | null;
  groupOnly?: boolean | null;
  vitalCode?: string | null;
  config?: string | null;
  entityType?: keyof typeof EntityType | null;
  entityId?: string | null;
  parent?: ISpecialityVitals | null;
  specialty?: IEspecialty;
  language?: ILanguage | null;
}

export const defaultValue: Readonly<ISpecialityVitals> = {
  active: false,
  forAppointment: false,
  forPrescription: false,
  groupOnly: false,
};
